const remove = (item: Element): void => {
    item?.remove();
};

const resetMetaTags = (): void => {
    try {
        document.querySelectorAll('meta[property^="og:"]')?.forEach(remove);
        document.querySelectorAll('meta[property^="product:"]')?.forEach(remove);
        document.querySelectorAll('meta[name="digitalSourceType"]')?.forEach(remove);
    } catch (e) {}
};

export default resetMetaTags;
